<div class="card">
    <div class="table-container">
        <p-table stripedRows #ExpenseItemTable [value]="expenseItems" [style]="{ 'min-width': '100em' }" scrollHeight="65em"
        [scrollable]="true" editMode="row" dataKey="EIListID">

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="17" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header>
            <tr>
                <th class="status-cell">
                    <i class="pi pi-exclamation-circle" title="Status"></i>
                </th>
                <th pSortableColumn="ExpenseItem">
                    Expense Item
                        <p-sortIcon field="ExpenseItem" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="ExpenseItem" display="menu" class="ml-auto" />
                </th>
                <th pSortableColumn="ExpenseItemTypeName">
                    Item Type
                        <p-sortIcon field="ExpenseItemTypeName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="ExpenseItemTypeName" display="menu" class="ml-auto" />
                </th>

                <th pSortableColumn="AccountName">
                    Account
                        <p-sortIcon field="AccountName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="AccountName" display="menu" class="ml-auto" />
                </th>

                <th pSortableColumn="IsExpenseEntry">
                    Available for Expense Entry
                        <p-sortIcon field="IsExpenseEntry" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-expenseitem let-ri="rowIndex">
            <tr>
                <td class="status-cell">
                    <div style="height: 2em; align-self: center">
                        <a (click)="
                                ShowError.next(expenseitem)
                            ">
                            <div>
                                <ef-status-icon [status]="
                                expenseitem?.Status
                                            ?.StatusCode
                                    " [message]="
                                    expenseitem?.Status
                                            ?.Message
                                    "></ef-status-icon>
                            </div>
                        </a>
                    </div>
                </td>
                <td>
                    {{expenseitem.ExpenseItem}}
                </td>
                <td>
                    {{expenseitem.ExpenseItemTypeName}}
                </td>
                <td>
                    {{expenseitem.AccountName}}
                </td>
                <td pEditableColumn>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-checkbox [(ngModel)]="expenseitem.IsExpenseEntry" binary="true" inputId="binary" (onChange)="IsExpenseEntryChecked($event, expenseitem)"></p-checkbox>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <p-checkbox [(ngModel)]="expenseitem.IsExpenseEntry" binary="true" inputId="binary" (onChange)="IsExpenseEntryChecked($event, expenseitem)"></p-checkbox>
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
    </p-table>
    </div>

</div>
